const en = {
  brand: 'GDL eStore',
  aboutUs: 'About us',
  solutions: 'Solutions',
  technologies: 'Technologies',
  team: 'Team',
  caseStudies: 'Case Studies',
  ourWork: 'Our Work',
  contactUs: 'Contact Us',
  mainTitle: 'Transform Your Ideas Into Powerful Software',
  mainDescription:
    'We partner with forward-thinking organizations to build scalable, innovative software solutions that drive real business impact.',
  aboutUsTitle: 'About us',
  aboutUsDescription:
    'We are a software company with {{years}} years of proven success, powered by a team with over {{expyears}} years of combined expertise. We specialize in building transformative technology solutions for businesses of all sizes.',
  technologiesTitle: 'Our Technology Stack',
  technologiesDescription:
    'We work with cutting-edge technologies and frameworks used by industry leaders. Our team stays at the forefront of innovation, continuously learning and implementing best practices to deliver modern, future-proof solutions.',
  teamTitle: 'Meet Our Team',
  teamDescription:
    'Our diverse team of experienced engineers and strategists is passionate about solving complex problems and delivering excellence. We value collaboration, innovation, and continuous learning.',
  caseStudiesTitle: 'Recent Projects',
  caseStudiesDescription:
    "Explore some of our recent work and see how we've helped businesses achieve their goals through innovative software solutions.",
  areYouInterestedTitle: 'Ready to transform your vision?',
  solutionsTitle: 'Our Services',
  solutionsB2BTitle: 'B2B Solutions',
  solutionsB2BDescription:
    'Enterprise software solutions designed to streamline operations, enhance productivity, and drive growth for organizations of all scales.',
  solutionsB2CTitle: 'Consumer Applications',
  solutionsB2CDescription:
    'User-centric applications that engage and delight consumers, from mobile apps to web platforms with intuitive interfaces.',
  solutionsFullStackTitle: 'Full-Stack Development',
  solutionsFullStackDescription:
    'End-to-end software development services covering everything from mobile and web to backend systems and cloud infrastructure.',
  socialMedia: 'Social Media',
  twitter: 'Twitter',
  instagram: 'Instagram',
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  github: 'GitHub',
  portfolio: 'Portfolio',
  portfolioMobile: 'Mobile Applications',
  portfolioWeb: 'Web Applications',
  portfolioDesktop: 'Desktop Applications',
  footerContactTitle: 'Get in Touch',
  footerContactWhatsApp: 'WhatsApp',
  footerContactPhone: 'Phone',
  footerContactEmail: 'Email',
  reservedRights: 'All rights reserved.',
  leaveUsAMessage: 'Send us a Message',
  whatIsYourEmail: 'Your email address',
  whatIsYourMessage: 'Tell us about your project',
  send: 'Send Message',
  invalidEmail: 'Please enter a valid email address',
  invalidContent: 'Please provide more details about your project or inquiry',

  // Hero section
  heroInnovativeSolutions: 'Innovative Software Solutions',
  heroGetStarted: 'Get Started',
  heroLearnMore: 'Learn More',
  heroPerformance: 'Performance',
  heroPerformanceDesc: 'Optimized solutions for lightning-fast execution',
  heroSecurity: 'Security',
  heroSecurityDesc: 'Enterprise-grade security and compliance standards',
  heroScalability: 'Scalability',
  heroScalabilityDesc: 'Infrastructure that grows with your business needs',

  // About section
  aboutDeliveringExcellence: 'Delivering Excellence',
  aboutParagraph:
    "With {{years}} years of proven success, we've built a reputation for delivering innovative software solutions that transform businesses. Our team brings over {{expyears}} years of combined experience across diverse industries and technologies.",
  aboutProjectsCompleted: 'Projects Completed',
  aboutHappyClients: 'Happy Clients',
  aboutTeamMembers: 'Team Members',
  aboutAvgRating: 'Avg Rating',
  aboutTechStack: 'Technology Stack',

  // Team values
  teamValueInnovation: 'Innovation',
  teamValueInnovationDesc:
    'We embrace cutting-edge technologies and creative solutions to solve complex challenges.',
  teamValueCollaboration: 'Collaboration',
  teamValueCollaborationDesc:
    'Working closely with clients and team members to ensure success at every step of the journey.',
  teamValueExcellence: 'Excellence',
  teamValueExcellenceDesc:
    'Committed to delivering high-quality code and exceptional experiences that exceed expectations.',
  teamValueLearning: 'Continuous Learning',
  teamValueLearningDesc:
    'Staying at the forefront of industry trends and investing in professional growth daily.',

  // Contact form labels
  contactEmail: 'Email',
  contactPhone: 'Phone',
  contactWhatsApp: 'WhatsApp',

  // Services section
  servicesSubtitle:
    'Comprehensive software solutions tailored to your business needs and objectives.',
  servicesFeatureB2BOne: 'Enterprise Architecture',
  servicesFeatureB2BTwo: 'API Integration',
  servicesFeatureB2BThree: 'Custom Development',
  servicesFeatureB2COne: 'User Experience',
  servicesFeatureB2CTwo: 'Multi-Platform',
  servicesFeatureB2CThree: 'Real-time Capabilities',
  servicesFeatureFullStackOne: 'Cloud Infrastructure',
  servicesFeatureFullStackTwo: 'DevOps Integration',
  servicesFeatureFullStackThree: 'Microservices Architecture',
  servicesLearnMore: 'Learn More',

  // Footer section
  footerNavigation: 'Navigation',
  footerServices: 'Services',
  footerB2BText: 'B2B Solutions',
  footerB2CText: 'Consumer Apps',
  footerFullStackText: 'Full-Stack Dev',
  footerSubtitle: 'Transforming ideas into extraordinary software solutions.',

  // Contact Us section
  contactGetInTouch: 'Get in Touch',
  contactFollowUs: 'Follow Us',
  contactFormSubtitle:
    "We'd love to hear from you. Send us a message and we'll respond as soon as possible.",
  contactResponseTime: 'We typically respond within 24 hours.',
  contactBackToHome: 'Back to Home'
};

const es = {
  brand: 'gdlestore',
  aboutUs: 'Acerca de nosotros',
  solutions: 'Soluciones',
  technologies: 'Tecnologias',
  team: 'Equipo',
  caseStudies: 'Casos de Estudio',
  ourWork: 'Nuestro trabajo',
  contactUs: 'Contactanos',
  mainTitle: 'Transforma Tus Ideas en Software Poderoso',
  mainDescription:
    'Nos asociamos con organizaciones innovadoras para construir soluciones de software escalables que generan impacto empresarial real.',
  aboutUsTitle: 'Acerca de nosotros',
  aboutUsDescription:
    'Somos una empresa de software con {{years}} años de éxito demostrado, impulsada por un equipo con más de {{expyears}} años de experiencia combinada. Nos especializamos en construir soluciones tecnológicas transformadoras para empresas de todos los tamaños.',
  technologiesTitle: 'Nuestro Stack Tecnológico',
  technologiesDescription:
    'Trabajamos con tecnologías de punta y marcos utilizados por líderes de la industria. Nuestro equipo se mantiene a la vanguardia de la innovación, aprendiendo continuamente e implementando las mejores prácticas.',
  teamTitle: 'Conoce Nuestro Equipo',
  teamDescription:
    'Nuestro equipo diverso de ingenieros experimentados está apasionado por resolver problemas complejos y entregar excelencia. Valoramos la colaboración, la innovación y el aprendizaje continuo.',
  caseStudiesTitle: 'Proyectos Recientes',
  caseStudiesDescription:
    'Explora algunos de nuestros trabajos recientes y ve cómo hemos ayudado a empresas a alcanzar sus objetivos a través de soluciones innovadoras.',
  areYouInterestedTitle: '¿Listo para transformar tu visión?',
  solutionsTitle: 'Nuestros Servicios',
  solutionsB2BTitle: 'Soluciones B2B',
  solutionsB2BDescription:
    'Soluciones de software empresarial diseñadas para optimizar operaciones, mejorar productividad e impulsar el crecimiento de organizaciones de todos los tamaños.',
  solutionsB2CTitle: 'Aplicaciones de Consumidor',
  solutionsB2CDescription:
    'Aplicaciones centradas en el usuario que atraen y deleitan a los consumidores, desde apps móviles hasta plataformas web con interfaces intuitivas.',
  solutionsFullStackTitle: 'Desarrollo Full-Stack',
  solutionsFullStackDescription:
    'Servicios de desarrollo de software completo que abarcan desde aplicaciones móviles y web hasta sistemas backend e infraestructura en la nube.',
  socialMedia: 'Redes Sociales',
  twitter: 'Twitter',
  instagram: 'Instagram',
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  github: 'GitHub',
  portfolio: 'Portafolio',
  portfolioMobile: 'Aplicaciones Móviles',
  portfolioWeb: 'Aplicaciones Web',
  portfolioDesktop: 'Aplicaciones de Escritorio',
  footerContactTitle: 'Ponte en Contacto',
  footerContactWhatsApp: 'WhatsApp',
  footerContactPhone: 'Teléfono',
  footerContactEmail: 'Correo Electrónico',
  reservedRights: 'Todos los derechos reservados.',
  leaveUsAMessage: 'Envíanos un Mensaje',
  whatIsYourEmail: 'Tu dirección de correo electrónico',
  whatIsYourMessage: 'Cuéntanos sobre tu proyecto',
  send: 'Enviar Mensaje',
  invalidEmail: 'Por favor ingresa una dirección de correo válida',
  invalidContent: 'Por favor proporciona más detalles sobre tu proyecto o consulta',

  // Hero section
  heroInnovativeSolutions: 'Soluciones de Software Innovadoras',
  heroGetStarted: 'Comenzar',
  heroLearnMore: 'Más Información',
  heroPerformance: 'Rendimiento',
  heroPerformanceDesc: 'Soluciones optimizadas para ejecución ultra rápida',
  heroSecurity: 'Seguridad',
  heroSecurityDesc: 'Estándares de seguridad y cumplimiento de nivel empresarial',
  heroScalability: 'Escalabilidad',
  heroScalabilityDesc: 'Infraestructura que crece con las necesidades de tu negocio',

  // About section
  aboutDeliveringExcellence: 'Entregando Excelencia',
  aboutParagraph:
    'Con {{years}} años de éxito demostrado, hemos construido una reputación por entregar soluciones de software innovadoras que transforman negocios. Nuestro equipo trae más de {{expyears}} años de experiencia combinada en diversas industrias y tecnologías.',
  aboutProjectsCompleted: 'Proyectos Completados',
  aboutHappyClients: 'Clientes Satisfechos',
  aboutTeamMembers: 'Miembros del Equipo',
  aboutAvgRating: 'Calificación Promedio',
  aboutTechStack: 'Stack Tecnológico',

  // Team values
  teamValueInnovation: 'Innovación',
  teamValueInnovationDesc:
    'Abrazamos tecnologías de vanguardia y soluciones creativas para resolver desafíos complejos.',
  teamValueCollaboration: 'Colaboración',
  teamValueCollaborationDesc:
    'Trabajar estrechamente con clientes y miembros del equipo para garantizar el éxito en cada paso del camino.',
  teamValueExcellence: 'Excelencia',
  teamValueExcellenceDesc:
    'Comprometidos a entregar código de alta calidad y experiencias excepcionales que superen expectativas.',
  teamValueLearning: 'Aprendizaje Continuo',
  teamValueLearningDesc:
    'Mantenerse a la vanguardia de las tendencias de la industria e invertir en crecimiento profesional diario.',

  // Contact form labels
  contactEmail: 'Correo Electrónico',
  contactPhone: 'Teléfono',
  contactWhatsApp: 'WhatsApp',

  // Services section
  servicesSubtitle:
    'Soluciones de software integral adaptadas a tus necesidades y objetivos comerciales.',
  servicesFeatureB2BOne: 'Arquitectura Empresarial',
  servicesFeatureB2BTwo: 'Integración de API',
  servicesFeatureB2BThree: 'Desarrollo Personalizado',
  servicesFeatureB2COne: 'Experiencia del Usuario',
  servicesFeatureB2CTwo: 'Multiplataforma',
  servicesFeatureB2CThree: 'Capacidades en Tiempo Real',
  servicesFeatureFullStackOne: 'Infraestructura en la Nube',
  servicesFeatureFullStackTwo: 'Integración DevOps',
  servicesFeatureFullStackThree: 'Arquitectura de Microservicios',
  servicesLearnMore: 'Más Información',

  // Footer section
  footerNavigation: 'Navegación',
  footerServices: 'Servicios',
  footerB2BText: 'Soluciones B2B',
  footerB2CText: 'Aplicaciones de Consumidor',
  footerFullStackText: 'Desarrollo Full-Stack',
  footerSubtitle: 'Transformando ideas en soluciones de software extraordinarias.',

  // Contact Us section
  contactGetInTouch: 'Ponte en Contacto',
  contactFollowUs: 'Síguenos',
  contactFormSubtitle:
    'Nos encantaría escucharte. Envíanos un mensaje y responderemos lo antes posible.',
  contactResponseTime: 'Típicamente respondemos dentro de 24 horas.',
  contactBackToHome: 'Volver al Inicio'
};

export { en, es };
